import { isElectron } from "./ElectronUtils";
import { loadedPlugins } from "@/Plugins/LoadedPlugins";
let onMenuItemClickAlreadySetup = false;
/**
 * Collapse the first sublevel of the menu.
 *
 * @param  {any[]} menu  The menu.
 * @returns {any[]}  The collapsed menu.
 */
function collapseFirstSublevel(menu) {
    const collapsedMenu = [];
    menu.forEach((item) => {
        if (item.submenu) {
            const collapsedSubmenu = [];
            item.submenu.forEach((subItem, index) => {
                if (subItem.submenu) {
                    subItem.submenu.forEach((nestedItem) => {
                        collapsedSubmenu.push(nestedItem);
                    });
                    if (index < item.submenu?.length - 1) {
                        collapsedSubmenu.push({ type: "separator" });
                    }
                }
                else {
                    collapsedSubmenu.push(subItem);
                }
            });
            collapsedMenu.push({ ...item, submenu: collapsedSubmenu });
        }
        else {
            collapsedMenu.push(item);
        }
    });
    return collapsedMenu;
}
/**
 * Setup the Electron menu.
 *
 * @param  {IMenuEntry[]} menuData  The menu data.
 */
export function setupElectronMenu(menuData) {
    if (!isElectron()) {
        return;
    }
    // Hide #menuContainer
    const menuContainer = document.getElementById("menuContainer");
    if (menuContainer) {
        menuContainer.style.display = "none";
    }
    /**
     * Recursively create the menu.
     *
     * @param  {IMenuItem|IMenuSubmenu} menuEntry  The menu entry.
     * @returns {any}  The new menu entry.
     */
    const recurseFunc = function (menuEntry) {
        const newEntry = {
            label: menuEntry.text,
        };
        if (menuEntry.hotkey) {
            let { hotkey } = menuEntry;
            // If it's an array, keep the first one.
            if (Array.isArray(hotkey)) {
                hotkey = hotkey[0];
            }
            if (hotkey !== "" && hotkey !== undefined) {
                newEntry["accelerator"] = `CmdOrCtrl+${hotkey.toUpperCase()}`;
            }
        }
        if (menuEntry.pluginId) {
            newEntry["pluginId"] = menuEntry.pluginId;
        }
        if (menuEntry.items) {
            newEntry["submenu"] = menuEntry.items.map(recurseFunc);
        }
        return newEntry;
    };
    let menu = menuData.map(recurseFunc);
    menu = collapseFirstSublevel(menu);
    window.electronAPI.setupMenu(menu);
    if (!onMenuItemClickAlreadySetup) {
        // Register the menu item click handler
        window.electronAPI.onMenuItemClick((pluginId) => {
            const plugin = loadedPlugins[pluginId];
            plugin.menuOpenPlugin();
        });
        onMenuItemClickAlreadySetup = true;
    }
}
